export const DATA_REQUEST_AUTH_HEADER_TITLE = 'data.request.auth.header.title';
export const DATA_REQUEST_CONFIRM_HEADER_TITLE =
  'data.request.confirm.header.title';
export const DATA_REQUEST_CONFIRM_MESSAGE_TITLE =
  'data.request.confirm.message.title';
export const DATA_REQUEST_CONFIRM_MESSAGE_SUBTITLE =
  'data.request.confirm.message.subtitle';
export const DATA_REQUEST_CONFIRM_MESSAGE_BUTTON_LABEL =
  'data.request.confirm.message.button.label';
